module.exports = __webpack_public_path__ + "static/media/02.edc46c96.png";